'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

require('./App.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AboutUs = function (_React$Component) {
    _inherits(AboutUs, _React$Component);

    function AboutUs() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AboutUs);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AboutUs.__proto__ || Object.getPrototypeOf(AboutUs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AboutUs, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            // 语言设置
            var paramLang = search.get("lang");
            if (null == paramLang || paramLang.length === 0) {
                //paramLang = "chs";
            }
            _Locale2["default"].GetInstance().InitLang(paramLang, navigator.language || navigator.userLanguage);

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('support_title');
        }
    }, {
        key: 'render',
        value: function render() {

            var local = _Locale2["default"].GetInstance();
            var titleText = local.getMessagebyId('www_title');

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' })
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'aboutus' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'companychs' },
                        '\u5317\u4EAC\u5C0F\u5FAE\u4E91\u670D\u79D1\u6280\u6709\u9650\u516C\u53F8'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'companyusa' },
                        'Beijing Xiaowei Cloud Inc.'
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'introduce' },
                        '\u5317\u4EAC\u5C0F\u5FAE\u4E91\u670D\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF0C\u6210\u7ACB\u4E8E2018\u5E742\u6708\u3002\u662F\u4E00\u5BB6\u4E13\u6CE8\u4E8E\u529E\u516C\u6548\u7387\u5DE5\u5177\u8F6F\u4EF6\u5F00\u53D1\u7684\u79D1\u6280\u516C\u53F8\u3002\u6211\u4EEC\u81F4\u529B\u4E8E\u4E3A\u7528\u6237\u63D0\u4F9B\u9AD8\u6548\u3001\u6109\u60A6\u7684\u529E\u516C\u4F53\u9A8C\uFF0C\u6253\u9020\u4E86\u4E00\u7CFB\u5217\u5B9E\u7528\u7684\u529E\u516C\u8F85\u52A9\u8F6F\u4EF6\u3002',
                        _react2["default"].createElement('br', null),
                        '\u65E5\u5386\u6E05\u5355\uFF0C\u5C0F\u5FAE\u4FBF\u7B7E\u662F\u516C\u53F8\u65D7\u4E0B\u7684\u8F6F\u4EF6\u3002\u6211\u4EEC\u7684\u4EA7\u54C1\u4EE5\u7B80\u6D01\u3001\u6613\u7528\u3001\u9AD8\u6548\u4E3A\u7279\u70B9\uFF0C\u6DF1\u53D7\u7528\u6237\u559C\u7231\u3002\u672A\u6765\uFF0C\u6211\u4EEC\u5C06\u7EE7\u7EED\u4E0D\u65AD\u521B\u65B0\uFF0C\u4E3A\u7528\u6237\u63D0\u4F9B\u66F4\u591A\u4F18\u8D28\u7684\u529E\u516C\u6548\u7387\u5DE5\u5177\u8F6F\u4EF6\u3002',
                        _react2["default"].createElement('br', null),
                        '\u516C\u53F8\u5730\u5740\uFF1A\u5317\u4EAC\u5E02\u6D77\u6DC0\u533A\u7FE0\u5FAE\u4E2D\u91CC14\u53F7\u697C\u4E09\u5C42A460'
                    )
                )
            );
        }
    }]);

    return AboutUs;
}(_react2["default"].Component);

exports["default"] = AboutUs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./AboutUs.js
// module id = 628
// module chunks = 0